export default __webpack_public_path__ + "static/media/MV.7e523676.svg";